/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Btn_ResetInputs */

const en_btn_reset = /** @type {(inputs: Btn_ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reset`)
};

/**
* | output |
* | --- |
* | "Reset" |
*
* @param {Btn_ResetInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const btn_reset = /** @type {((inputs?: Btn_ResetInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Btn_ResetInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_btn_reset(inputs)
});